import type { ReactNode } from 'react';
import { SITE_DRIP_SURFACE } from '../../../constants/siteUi';

export function DripSection({
  id,
  title,
  description,
  action,
  children,
}: {
  id?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section
      id={id}
      className={`scroll-mt-28 ${SITE_DRIP_SURFACE} p-5 md:p-6`}
      aria-labelledby={id ? `${id}-title` : undefined}
    >
      <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h2 id={id ? `${id}-title` : undefined} className="font-display text-base font-bold uppercase tracking-[0.08em] text-[var(--home-text-on-dark)]">
            {title}
          </h2>
          {description ? (
            <p className="mt-1 max-w-2xl font-body text-xs leading-relaxed text-[var(--home-muted-on-dark)]">
              {description}
            </p>
          ) : null}
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </div>
      {children}
    </section>
  );
}
